// libs
import { useDispatch } from 'react-redux'
// types
import { IField, IFieldValueInput } from 'types/graphql'
// store
import { addRiskFieldValue } from 'store/reducers/offlineRisk'
// hooks
import { useOfflineQueue } from 'hooks/offline/useOfflineQueue'
// utils
import { generateTempId } from 'utils/helpers'

export const useOfflineFieldUpsert = () => {
  const dispatch = useDispatch()

  const { addMutation, tempIdMappings, fieldValueMappings } = useOfflineQueue()

  const offlineFieldUpsert = (variables: { entityId: string; input: IFieldValueInput[] }, field: IField) => {
    const entityId = tempIdMappings[variables.entityId] || variables.entityId

    const { fieldId, fieldValueId, value, fieldLinkId, parentFieldValueId } = variables.input[0]

    const fieldValue = {
      fieldLinkId,
      parentFieldValueId,
      fieldValueId: null,
      createdAt: new Date().toString(),
      fieldId: field.id,
      fieldName: field.name,
      fieldValue: value,
      fieldType: field.fieldType,
      fieldLabel: field.label
    }

    if (fieldId && !fieldValueId) {
      const tempFieldValueId = generateTempId()

      addMutation({
        type: 'fieldUpsert',
        variables: {
          ...variables,
          entityId
        },
        tempId: tempFieldValueId,
        dependsOn: entityId.startsWith('temp_') ? entityId : null
      })

      dispatch(
        addRiskFieldValue({
          riskId: entityId,
          fieldValue: { ...fieldValue, fieldValueId: tempFieldValueId }
        })
      )

      return {
        data: {
          fieldValueUpsert: [{ id: tempFieldValueId }]
        }
      }
    } else if (fieldValueId) {
      const realFieldValueId = fieldValueMappings[fieldValueId] || fieldValueId

      addMutation({
        type: 'fieldUpsert',
        variables: {
          entityId,
          input: [
            {
              ...variables.input[0],
              fieldValueId: realFieldValueId
            }
          ]
        },
        dependsOn: entityId.startsWith('temp_') ? entityId : null
      })

      dispatch(addRiskFieldValue({ riskId: entityId, fieldValue: { ...fieldValue, fieldValueId: realFieldValueId } }))

      return {
        data: {
          fieldValueUpsert: [{ id: realFieldValueId }]
        }
      }
    }
  }

  return offlineFieldUpsert
}
